<template>
  <pt-lab-product-detail v-loading="loading" :labProduct="labProduct" @goDelete="goDelete"></pt-lab-product-detail>
</template>

<script>
import PtLabProductDetail from './index'
export default {
  name: 'pt-lab-product-detail__withData',
  components: {
    'pt-lab-product-detail': PtLabProductDetail
  },
  data () {
    return {
      loading: false,
      labProduct: {}
    }
  },
  methods: {
    load (id) {
      this.loading = true
      this.$store.dispatch('getLabProduct', id).then(data => {
        if (data.testCycle) {
          data.testCycle = data.testCycle.replace(/[^0-9]/ig, '')
        }
        this.labProduct = data
      }).catch(err => {
        this.$message.error(err)
      }).finally(()=>{
        this.loading = false
      })
    },
    goDelete (data) {
      this.$confirm('确定要删除检测项目' + data.itemName + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('deleteLabProduct', data.id).then(res => {
          this.$message.success('删除成功!')
          this.loading = false
          history.go(-1)
        }).catch(err => {
          this.loading = false
          console.error(err)
          this.$message.error('删除失败!')
        })
      })
    }
  },
  created () {
    if (this.$route.params.id) {
      this.load(this.$route.params.id)
    }
  }
}
</script>
